module.exports = __webpack_public_path__ + "static/media/47 - UB40 - Kingston Town.2061516d.mp3";